<template>
  <div class="jobs-report" v-loading="loader">
    <div class="job-row-container">
      <i :class="['fas fa-chevron-right', {expand: expand}]" @click="expandHandler"></i>

      <el-input placeholder="Поиск ..." v-model="search" class="input-search">
        <el-button slot="append" icon="el-icon-search"></el-button>
      </el-input>

    </div>
    <div class="wrapper-table">

      <el-table
        border
        :row-class-name="rowClassName"
        class="sticky-header-table"
        height="calc(100vh - 120px)"
        default-expand-all
        :data="filteredTableData"
        ref="table"
        style="width: 100%;margin-bottom: 20px;"
        row-key="key"
      >
        <el-table-column
          prop="name"
          min-width="300"
          label="Наименование"
        >
          <template slot-scope="scope">
          <span v-if="!scope.row.isChild" class="parent">
            <strong class="name-abs">
              {{ scope.row.name }}
            </strong>
          </span>
            <span v-else>
              {{ scope.row.name }}, {{scope.row.unit}}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="user"
          label="Исполнитель"
          min-width="220"
        >
          <template slot-scope="scope">
            <span>
             {{ scope.row.user }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="totalValue"

          label="Физ объемы"
          width="120">
          <template slot-scope="scope">
            <strong v-if="!scope.row.isChild">
              {{ formatNumberSpace(scope.row.plan) }}
            </strong>
            <span v-else>
              {{ formatNumberSpace(scope.row.plan) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="price_unit"
          v-if="$store.state.project.price"

          label="Стоимость на ед"
          width="140">
          <template slot-scope="scope">
            <strong v-if="!scope.row.isChild">
              {{ formatNumberSpace(scope.row.price_unit) }}
            </strong>
            <span v-else>
              {{ formatNumberSpace(scope.row.price_unit) }}
            </span>
          </template>
        </el-table-column>

        <el-table-column
          prop="price_plan"
          v-if="$store.state.project.price"

          label="Стоимость всего"
          width="140">
          <template slot-scope="scope">
            <strong v-if="!scope.row.isChild">
              {{ formatNumberSpace(scope.row.price_plan) }}
            </strong>
            <span v-else>
              {{ formatNumberSpace(scope.row.price_plan) }}
            </span>
          </template>
        </el-table-column>

        <el-table-column
          prop="unit_for_value"

          label="Трудоемкость на ед."
          v-if="$store.state.project.progress"
          width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.isChild">
              {{ formatNumberSpace(scope.row.workType.unit_for_value) }}
            </span>
          </template>
        </el-table-column>

        <el-table-column
          prop="price_plan"
          v-if="$store.state.project.progress"
          label="Трудоемкость всего"
          width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.isChild">
              {{ formatNumberSpace(parseFloat((Number(scope.row.workType.unit_for_value || 0) *  Number(scope.row.plan)).toFixed(2))) }}
            </span>
          </template>
        </el-table-column>


        <el-table-column
          prop="start_date"
          v-if="$store.state.project.deadline_accounting"
          label="Дата начала"
          width="120">
          <template slot-scope="scope">
             <span>
              {{ scope.row.start_date}}
            </span>
          </template>
        </el-table-column>


        <el-table-column
          prop="end_date"
          v-if="$store.state.project.deadline_accounting"
          label="Дата окончания"
          width="140">
          <template slot-scope="scope">
            <span>
              {{ scope.row.end_date}}
            </span>
          </template>
        </el-table-column>

        <el-table-column
          prop="price_plan"

          label="Вид работ"
          width="200">
          <template slot-scope="scope">
            <span>
              {{scope.row.work_type_name}}
            </span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import {apiUrl} from "../../../plugins/firebase";
import firebase from "firebase";
import dayjs from "dayjs";
import axios from "axios";
import {formatNumberSpace} from "../../../utils/numberUtils";
import _ from "lodash";
import {filterObjects} from "../../../utils/filterJobs";
import {getChildList} from "../../../utils/getChild";

export default {
  name: "JobReport",
  data() {
    return {
      tableData: [],
      expandedRows: [],
      search: '',
      loader: false,
      expand: true,
      config: {
        plan: false,
        fact: false,
        diffPlan: false,
        percentagePlan: false,
        pricePlan: false,
        priceFact: false,
        priceDiffPlan: false,
        pricePercentagePlan: false,
        laborIntensityPlan: false,
        laborIntensityFact: false,
        laborIntensityDiffPlan: false,
        laborIntensityPercentagePlan: false,
      }
    }
  },
  async mounted() {
    // this.loading = true



    this.fetchTree()

    // const response = await axios.get(`${apiUrl}${params}`);
    //
    // if (response && response.data && response.data.data && response.data.data.jobsData && response.data.data.jobsData.objects) {
    //   let objects = Object.values(response.data.data.jobsData.objects);
    //
    //
    //   objects = objects.map((obj, id) => {
    //     obj.children = Object.values(obj.jobs).map((j, id) => {
    //       Object.keys(j).forEach((k) => {
    //         if (this.config[k] !== undefined) {
    //           this.config[k] = true
    //         }
    //       })
    //       j.isChild = true
    //       j.id = id;
    //       return j
    //     })
    //
    //     if (!obj.children.length) {
    //       obj.children = [{
    //         diffPlan: "",
    //         executor: "",
    //         fact: "",
    //         id: '',
    //         index: '',
    //         isHide: true,
    //         isChild: '',
    //         name: "-",
    //         percentagePlan: "",
    //         plan: ""
    //       }]
    //     }
    //     obj.id = id
    //     return obj
    //   })
    //
    //
    //   if (this.$route.query.isLaborIntensity || this.$route.query.isPrice) {
    //     objects[objects.length] = {
    //       name: 'Итого',
    //       isTotal: true,
    //       ...response.data.data.jobsData,
    //
    //       children: [{
    //         diffPlan: "",
    //         executor: "",
    //         fact: "",
    //         id: '',
    //         index: '',
    //         isHide: true,
    //         isChild: '',
    //         name: "-",
    //         percentagePlan: "",
    //         plan: ""
    //       }]
    //     }
    //   }
    //
    //   this.tableData = objects;
    //   this.loading = false
    // }
  },
  computed: {
    // Фильтрация данных по названию (name) для родителей и детей
    filteredTableData() {

      return this.tableData.filter(data => !this.search ||  ((data && data.name) ||  '').toLowerCase().includes(this.search.toLowerCase()))

    },
  },
  methods: {
    async fetchTree() {
      this.loader = true;
      const result = [];


      const userResponse =await myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('users')
        .get()


      const users = []

      userResponse.forEach((job) => {
        const available_jobs = []

        const jobData = job.data()

        if(jobData.available_jobs) {
          Object.values(jobData.available_jobs).forEach((d) => {
            d.forEach((d) => {
              available_jobs.push(d)
            })
          })
        }
        users.push({
          ...jobData,
          _id: job.id,
          available_jobs: available_jobs
        })
      })

      const workResponse =await myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('works_type')
        .where('type', '==', 'job')
        .get()


      const work_types = []

      workResponse.forEach((job) => {
        work_types.push({
          ...job.data(),
          id: job.id
        })
      })

      const jobResponse = await myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('jobs')
        .get()

      const jobs = []

      jobResponse.forEach((job, key) => {
        jobs.push({
          ...job.data(),
          isChild: true,
          key: job.id + '_' + key + job.data().name,
          _id: job.id
        })
      })


      const owner = users.find(({uid}) => this.$store.state.project.owner  === uid)
      let owner_name = ''
      if(owner) {
        owner_name = owner.name
      }

      myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('objects')
        .get()
        .then((data) => {
          data.forEach((subDoc, i) => {
            let jobObj = jobs.filter(({objects}) => objects.includes(subDoc.id))


            jobObj = jobObj.map((j) => {
              const workType = work_types.find(({id}) => id === j.work_type)
              const jobUsers = users.filter(({available_jobs}) => available_jobs.includes(j._id))


              let usersTxt = []

              if(jobUsers && jobUsers.length) {
                jobUsers.forEach((j) => {
                  usersTxt.push(j.name)
                })
              } else {
                usersTxt.push(owner_name)
              }

              j.user = usersTxt.join(', ')
              j.workType = workType || {}
              return j
            })

            jobObj = _.orderBy(jobObj, 'index', ['asc'])


            const data = subDoc.data();
            result.push({
              id: subDoc.id,
              name: data.name,
              objects: data.objects,
              key: data.name + subDoc.id +  data.index + '_' + i,
              index: data.index,
              parentId: data.parentId || undefined,
              isParent: data.isParent,
              children:jobObj.length? jobObj : [{
                diffPlan: "",
                executor: "",
                fact: "",
                id: '',
                index: '',
                isHide: true,
                key: 'chi' + data.name + subDoc.id +  data.index + '_' + i,
                isChild: '',
                name: "-",
                percentagePlan: "",
                plan: ""
              }]
            });
          });
        }).finally(() => {
        // if(isCache) {
        // }
        const objects = _.orderBy(getChildList(result), 'index', ['asc']);

        this.loader = false;

        this.tableData = objects;
      }).catch(() => {
        this.loader = false;
      });
    },
    rowClassName(row) {



      if (row.row.isHide) {
        return 'isHide'
      }

      if (row.row.isTotal) {
        return 'isTotal'
      }

      if (!row.row.isChild) {
        return 'isParent'
      }

      return ''
    },
    formatNumberSpace,
    expandHandler() {
      if (this.expand) {
        this.collapseAll()
      } else {
        this.expandAll()
      }

      this.expand = !this.expand
    },
    expandAll() {
      this.filteredTableData.forEach(row => {
        if (!this.expandedRows.includes(row.id)) {
          this.$refs.table.toggleRowExpansion(row, true);
          this.expandedRows.push(row.id);
        }
      });
    },
    collapseAll() {
      this.filteredTableData.forEach(row => {
        this.$refs.table.toggleRowExpansion(row, false);
      });
      this.expandedRows = [];
    },
  },
}
</script>
<style lang="scss">
.jobs-report {
   //padding-top: 48px;   // IOS ONLY

  .el-table__indent {
    display: none !important;
  }

  .el-table__header {
    .el-table__cell {
      padding: 4px 0;
    }
  }
}
</style>
<style scoped lang="scss">
.wrapper-table {
  padding-bottom: 3px;
}

.green {
  color: #13ce66;
}

.expand {
  transform: rotate(90deg);
}

.job-row-container {
  display: flex;
  align-items: center;
  width: 400px;
  margin-bottom: 12px;

  .fa-chevron-right {
    margin-right: 14px;
    margin-left: 10px;
    font-size: 16px;
    cursor: pointer;
  }
}

.red {
  color: red;
}

.jobs-report {
  max-width: 1320px;
  margin: 0 auto;
  width: calc(100% - 40px);

  .el-table .el-table__cell {
    padding: 4px 0;
  }

  margin-top: -24px !important;
}

.name-abs {
  width: 850px;
  position: absolute;
  z-index: 6;

  background: #fff;
  height: 46px;
  align-items: center;
  display: inline-flex;
  margin-top: -12px;
}

</style>

<style lang="scss">
.jobs-report {

    .el-table--enable-row-hover .el-table__body tr.isParent:hover>td.el-table__cell{
    background: #f7f7df !important;
  }

  .isParent{
    td, .name-abs {
      background: #f7f7df !important;
    }
    &:hover td.el-table__cell {
      background: #f7f7df !important;
    }
  }

  .isTotal {
    background: rgba(50, 205, 50, 0.2);

    .name-abs {
      background: rgba(0, 0, 0, 0);
    }

    .el-table__expand-icon {
      opacity: 0;
      width: 0;
    }
  }

  .isHide {
    display: none;
  }

  .el-table__header {
    .el-table .el-table__cell {
      padding: 4px 0;
    }
  }
}

.jobs-report {
  .el-table__expand-icon {
    .el-icon-arrow-right:before {
      content: "\f054" !important;
    }

    .el-icon-arrow-right {
      font-size: 14px !important;
      font-family: 'Font Awesome 5 Free' !important;
      speak: none;
      font-weight: 900 !important;
    }
  }


  .el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
    background: #fff !important;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Objects/JobsReportObjects.vue